import styled, { space, themeGet, device } from '@styled'
import { Link } from 'gatsby'

export const BoxImgInner = styled.div`
  margin-inline: auto;
  margin-block: 0;
  margin-left: 0;
  width: 100%;
`

export const BoxImgMedia = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: wrap;
  margin-block-end: 25px;
  max-width: 400px;
  transition: ${themeGet('transition')};
  ${device.large} {
    margin-block-end: 0px;
  }
  img {
    min-height: 200px;
    object-fit: cover;
    object-position: 60% center;
    &:not(:first-child) {
      margin-left: 5px;
    }
  }
`

export const Break = styled.div`
  width: 100%;
  height: 0;
`

export const BoxImgContent = styled.div``

export const BoxImgText = styled.div`
  font-size: 12px;
  margin-left: auto;
  color: ${themeGet('colors.text')};
`

export const HeadingWrap = styled.h5`
  font-weight: 500;
  line-height: 1.67;
  margin-block-end: 25px;
  font-size: 22px;
  ${device.xlarge} {
    font-size: 24px;
  }
`

export const TextWrap = styled.p`
  color: ${themeGet('colors.text')};
`

export const BoxImgLink = styled(Link)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  visibility: hidden;
  text-indent: -999999px;
`

export const BoxImgWrapper = styled.div`
  position: relative;
  background: #fff;
  padding-block-start: 40px;
  padding-block-end: 40px;
  padding-inline: 30px;
  display: flex;
  height: 100%;
  ${space};
`
